import { Media } from '@/payload-types'

export function getSeasonText(
  winter?: {
    title: string
    content: {
      root: {
        type: string
        children: {
          type: string
          version: number
          [k: string]: unknown
        }[]
        direction: ('ltr' | 'rtl') | null
        format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
        indent: number
        version: number
      }
      [k: string]: unknown
    } | null
    media: Media
  } | null,
  summer?: {
    title: string
    content: {
      root: {
        type: string
        children: {
          type: string
          version: number
          [k: string]: unknown
        }[]
        direction: ('ltr' | 'rtl') | null
        format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
        indent: number
        version: number
      }
      [k: string]: unknown
    } | null
    media: Media
  } | null,
  fallbackText?: string | null,
  date?: Date,
): {
  title: string
  content: {
    root: {
      type: string
      children: {
        type: string
        version: number
        [k: string]: unknown
      }[]
      direction: ('ltr' | 'rtl') | null
      format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
      indent: number
      version: number
    }
    [k: string]: unknown
  } | null
} | null {
  // Use provided date or fallback to a stable default
  const currentDate = date || new Date()
  const currentMonth = currentDate.getMonth() + 1 // getMonth() returns 0-11

  // Winter months: December (12), January (1), February (2)
  const isWinter = currentMonth === 12 || currentMonth === 1 || currentMonth === 2

  // Summer months: June (6), July (7), August (8)
  const isSummer = currentMonth >= 6 && currentMonth <= 8

  if (isWinter && winter?.title) {
    return { title: winter.title, content: winter.content }
  }

  if (isSummer && summer?.title) {
    return { title: summer.title, content: summer.content }
  }

  // Fallback to the default media if seasonal media is not available
  return null
}
